import CloseIcon from '../../../assets/icons/close.svg?react';
import { useState } from 'react';
import { useCreateCblModule } from '../../../hooks/queries/cblmoduleQueries';
const CblModuleAppendModal = ({ isOpen, onClose, onSuccess }) => {
  const [cblModuleAppendObject, setCblModuleAppendObject] = useState({
    moduleName: null,
    version: null,
    baseUrl: null,
  });
  const createCblModule = useCreateCblModule();
  const [isPending, setIsPending] = useState(false);
  if (!isOpen) return null;
  const handleCreateCblModule = async () => {
    try {
      setIsPending(true);
      await createCblModule.mutateAsync(cblModuleAppendObject);
      onSuccess();
    } catch (error) {
      console.error('CBL 모듈 추가 실패:', error);
      alert('CBL 모듈 추가에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  const handleChangeInput = (e) => {
    setCblModuleAppendObject({ ...cblModuleAppendObject, [e.target.name]: e.target.value });
  };
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>CBL 모듈 추가</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10 px-20 pt-10">
          <div className="flex flex-col gap-10">
            <div className="flex flex-col gap-2">
              <label htmlFor="moduleName" className='text-b2-400 text-gray-800'>모듈명</label>
              <input type="text" id="moduleName" name="moduleName" className='w-full input-primary' placeholder='모듈명을 입력해주세요.' value={cblModuleAppendObject.moduleName} onChange={handleChangeInput} />
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="version" className='text-b2-400 text-gray-800'>버전</label>
            <input type="text" id="version" name="version" className='w-full input-primary' placeholder='버전을 입력해주세요.' value={cblModuleAppendObject.version} onChange={handleChangeInput} />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="baseUrl" className='text-b2-400 text-gray-800'>API 엔드포인트</label>
            <input type="text" id="baseUrl" name="baseUrl" className='w-full input-primary' placeholder='BaseUrl을 입력해주세요.' value={cblModuleAppendObject.baseUrl} onChange={handleChangeInput} />
          </div>
          <div className="mt-10">
            <button className="btn btn-primary big-btn w-full" onClick={handleCreateCblModule} disabled={isPending}>{isPending ? '추가중...' : '추가'}</button>
          </div>
          {createCblModule.error && (
            <div className="mt-10 text-red-500 text-c2-400">
              CBL 모듈 추가에 실패했습니다.
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CblModuleAppendModal